import { put } from '..';
import { SensorLabel, MeterLabel, AssetCustomField } from '../../constants/Types';

export interface UpdateAssetBody {
  name: string,
  description: string,
  manufacturer: string,
  model: string,
  serial: string,
  locationId: string,
  customFields: AssetCustomField[],
  labels?: (SensorLabel | MeterLabel)[] | null,
}

interface UpdateAssetProps extends UpdateAssetBody {
  assetId: string,
}

const updateAsset = ({
  assetId, name, description, manufacturer, model, serial, locationId, customFields, labels,
}: UpdateAssetProps) => {
  const body: UpdateAssetBody = {
    name,
    description,
    manufacturer,
    model,
    serial,
    locationId,
    customFields,
  };

  if (labels) body.labels = labels;

  return put(`assets/v2/${assetId}`, body);
};

export default updateAsset;
